import { Element } from "react-scroll";
import { LuSendHorizontal } from "react-icons/lu";
import "../styles/sections/mail.css";
import mailPic from "../assets/images/mail.png";


export default function MailSection() {
  return (
    <Element className="section section--mail" name="mail">
      <div className="section-container">
        <img src={mailPic} alt="Send Email" className="section--mail__image" />
        <div className="section__head">
          <h1>Let’s Connect</h1>
          <p>
            Have a project in mind or just want to say hi? Feel free to reach
            out via email.
          </p>
        </div>
        <div className="section__wrapper">
          <h2>Say hi – just hit send </h2>
          <a href="mailto:abdallasalehco@gmail.com">
            <span>Send</span> <LuSendHorizontal />
          </a>
        </div>
      </div>
    </Element>
  );
}
